import { AnonymousUser, PersonaUser, User } from '®shared/auth';
import { AppConfig } from '®shared/config';
import { createUserPermissions, UserPermissions } from '®shared/permissions';
import { UserRecord } from '®shared/user';

export class CurrentUserAndPermissions {
  constructor(
    public oauthUser: User,
    public permissions: UserPermissions,
    public tarlUser: UserRecord | null,
  ) {}

  get hasTarlAccount(): boolean {
    return this.oauthUser && !this.oauthUser.isAnonymous ? true : false;
  }

  get hasTarlUserProfile(): boolean {
    // The email property of a TARL profile is mandatory, if it doesn't exist there must be no profile.
    return this.tarlUser && this.tarlUser.email ? true : false;
  }
}

export function currentAnonymousUser(
  appConfig: AppConfig,
  anonymousUser: AnonymousUser,
): CurrentUserAndPermissions {
  const permissions = createUserPermissions(appConfig, anonymousUser.scopes);
  return new CurrentUserAndPermissions(anonymousUser, permissions, null);
}

export function currentPersonaUser(
  appConfig: AppConfig,
  personaUser: PersonaUser,
  tarlUser: UserRecord | null,
): CurrentUserAndPermissions {
  const personaScopes = personaUser.scopes;
  const devolvedScopes = (tarlUser && tarlUser.devolvedAuthorisations) || [];

  const allScopes = [...personaScopes, ...devolvedScopes];

  const permissions = createUserPermissions(appConfig, allScopes);

  return new CurrentUserAndPermissions(personaUser, permissions, tarlUser);
}
